import { ClipboardList, Handshake, Search, CarFront } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { DepotVenteForm } from "@/components/DepotVenteForm";
import { PartnerBrb } from "@/components/PartnerBrb";
import { IMAGES } from "@/constants/images";

const steps = [
  {
    icon: CarFront,
    title: "Présentez-nous votre véhicule",
    text: "Apportez votre voiture au garage ou contactez-nous pour une première présentation.",
  },
  {
    icon: ClipboardList,
    title: "Communiquez ses caractéristiques",
    text: "Marque, modèle, année, kilométrage et historique d'entretien complet.",
  },
  {
    icon: Search,
    title: "Étudions ensemble les modalités",
    text: "Nous définissons avec vous les modalités du dépôt-vente adaptées à votre projet.",
  },
  {
    icon: Handshake,
    title: "Définissons les conditions de vente",
    text: "Un accord clair encadre la commercialisation de votre véhicule par un professionnel.",
  },
];

export default function DepotVentePage() {
  return (
    <div data-testid="depot-vente-page">
      <PageHero
        image={IMAGES.depotVente}
        imageAlt="Voiture de sport rouge présentée en showroom"
        imageTestid="depot-vente-bg-image"
        eyebrow="Dépôt-vente automobile"
        title="Vendez votre véhicule avec MECA AUTO CLEAN 01"
      >
        Vous souhaitez vendre votre voiture ? Le dépôt-vente permet de confier la
        commercialisation de votre véhicule à un professionnel, dans le cadre
        d'un accord définissant les modalités de vente, selon les conditions
        convenues avec le propriétaire.
      </PageHero>

      <section className="border-t border-border">
        <div className="mx-auto max-w-6xl px-4 py-20">
          <Reveal>
            <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
              Votre projet de vente en 4 étapes
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.08}>
                <div
                  data-testid={`depot-vente-step-${i + 1}`}
                  className="relative h-full rounded-lg border border-border bg-card p-6 transition-colors card-lift hover:border-primary/50"
                >
                  <span className="absolute right-4 top-4 font-display text-3xl font-bold text-primary/25">
                    {i + 1}
                  </span>
                  <s.icon className="h-7 w-7 text-primary" />
                  <h3 className="mt-4 font-semibold">{s.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-panel border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-20">
          <Reveal>
            <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
              Discutons de votre projet
            </h2>
            <p className="mb-8 mt-4 text-muted-foreground">
              Décrivez votre véhicule : votre demande part directement sur le
              WhatsApp du garage, avec une copie par e-mail.
            </p>
          </Reveal>
          <div className="rounded-lg border border-border bg-card p-6">
            <DepotVenteForm />
          </div>
        </div>
      </section>

      <PartnerBrb />
    </div>
  );
}
